import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.values.js";
import { getHotjarSettingsValues } from "@faire/help-center-utils/serialized-data/getHotjarSettingsValues";
import { getUserToken, getUserType } from "@faire/help-center-utils/serialized-data/getUser";
import { getSettingRecordSessionInHotjar } from "@faire/help-center-utils/settings/getSettingRecordSessionInHotjar";
import { trackHotjarConfigHotjarSettingConfigLimitExceededError } from "@faire/web-api/events/hotjarConfig/error/hotjarSettingConfigLimitExceeded";
import { IUser } from "@faire/web-api/indigofair/data/IUser";
import { Hotjar } from "@faire/web/common/hotjar/hotjar";
import { filterAndProcessHotjarSettings } from "@faire/web/common/hotjar/hotjarUtils";
var HOTJAR_CONFIG_MAX_SETTINGS = 80;
var HOTJAR_ID = 3231906;
var HOTJAR_SNIPPET_VERSION = 6;
export function initializeHotjar() {
  return _initializeHotjar.apply(this, arguments);
}
function _initializeHotjar() {
  _initializeHotjar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var shouldRecordSessionInHotjar, userToken, userType, processedSettings;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          shouldRecordSessionInHotjar = getSettingRecordSessionInHotjar();
          if (shouldRecordSessionInHotjar) {
            Hotjar.initialize(HOTJAR_ID, HOTJAR_SNIPPET_VERSION);
            userToken = getUserToken();
            userType = getUserType();
            processedSettings = filterAndProcessHotjarSettings(getHotjarSettingsValues(), HOTJAR_CONFIG_MAX_SETTINGS);
            if (userToken && userType !== IUser.Type.ADMIN) {
              if (Object.values(getHotjarSettingsValues()).length > HOTJAR_CONFIG_MAX_SETTINGS) {
                trackHotjarConfigHotjarSettingConfigLimitExceededError("help-center");
              }
              Hotjar.identify(userToken, processedSettings);
            }
          }
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _initializeHotjar.apply(this, arguments);
}